module.exports = __webpack_public_path__ + "img/IconoAdherible.7d0236cd.png";